<template>
  <section class="wrap">
    <div class="logo-wrap">
      <img class="logo" src="../assets/logo.svg" alt="emphasoft logo" />
    </div>
    <div class="login-wrap" :class="{ shake: isError }">
      <form class="login" @submit.prevent="checkValid">
        <div @click="changeColor('inputLogin')">
          <i
            class="fas fa-sign-in-alt icon"
            :class="{ active: isActiveSignIn }"
            aria-hidden="true"
          ></i>
          <input
            required
            v-model="username"
            value=""
            type="text"
            placeholder="Login"
          />
        </div>
        <div @click="changeColor('inputPassword')">
          <i class="fas fa-lock icon" :class="{ active: isActiveLock }"></i>
          <input
            required
            value=""
            v-model="password"
            type="password"
            placeholder="Password"
          />
        </div>
        <button class="login-button" type="submit">Login</button>
      </form>
    </div>
    <span class="invalid"> {{ invalid }}</span>
  </section>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      isActiveSignIn: false,
      isActiveLock: false,
      isError: false,
      invalid: ""
    };
  },
  mounted() {
    const inputLogin = document.querySelector('[placeholder="Login"]');
    const inputPassword = document.querySelector('[placeholder="Password"]');

    document.addEventListener("click", () => {
      if (!this.username.length) this.isActiveSignIn = false;
      if (!this.password.length) this.isActiveLock = false;
    });

    inputLogin.addEventListener("input", () => {
      this.isActiveSignIn = this.username.length ? true : false;
    });

    inputPassword.addEventListener("input", () => {
      this.isActiveLock = this.password.length ? true : false;
    });
  },
  methods: {
    login() {
      let username = this.username;
      let password = this.password;

      this.$store
        .dispatch("login", { username, password })
        .then(() => this.$router.push("/secure"))
        .catch(err => {
          console.log(err);
          this.isError = true;
          this.username = "";
          this.password = "";
          this.isActiveLock = false;
          this.isActiveSignIn = false;
          this.invalid = "wrong login or password".toUpperCase();
        });
      this.isError = false;
    },
    changeColor(icon) {
      icon === "inputLogin"
        ? (this.isActiveSignIn = true)
        : (this.isActiveLock = true);
    },
    checkValid() {
      this.invalid = "INVALID";
      this.isError = false;

      if (
        new RegExp("^[a-zA-Z][a-zA-Z0-9-_\\.]{1,20}$").test(this.username) &&
        new RegExp(
          "(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$"
        ).test(this.password)
      ) {
        this.invalid = "";
        this.login();
      }

      if (!new RegExp("^[a-zA-Z][a-zA-Z0-9-_\\.]{1,20}$").test(this.username)) {
        this.invalid += " USERNAME";
        this.isError = true;
      }

      if (
        !new RegExp(
          "(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$"
        ).test(this.password)
      ) {
        this.invalid += this.invalid.length > 7 ? " && PASSWORD" : " PASSWORD";
        this.isError = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  display: relative;

  background-color: #213a4f;
  padding: 10px;
  overflow-y: hidden;

  min-height: 600px;
  height: 100vh;
  width: 100vw;
}

.logo-wrap {
  display: flex;

  flex-direction: row;
  justify-content: center;

  padding-top: 150px;
  padding-bottom: 30px;

  width: 100%;
}

.logo {
  width: 300px;
}

.login-wrap {
  display: flex;

  margin: auto;

  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  background-color: #3f4f62;
  border-radius: 5px;

  max-width: 500px;
}

.login {
  width: 100%;
}

input {
  width: calc(100% - 5px);
  height: 80px;
  box-sizing: border-box;

  line-height: 24px;
  font-size: 18px;
  color: #698caa;

  border-right: 10px solid #3f4f62;
  margin-left: 5px;

  &::placeholder {
    font-size: 18px;

    color: #586c85;
  }

  &[placeholder="Login"] {
    border-bottom: 1px solid #586c85;

    border-radius: 0px 5px 0px 0px;
  }

  &:focus,
  &:active {
    width: calc(100% - 5px);

    box-sizing: border-box;
    border-right: 10px solid #698caa;

    font-size: 18px;
    color: #698caa;

    & + .icon {
      color: #698caa !important;
    }
  }
}

input:-webkit-autofill {
  -webkit-box-shadow: inset 0 0 0 50px #3f4f62 !important;
  -webkit-text-fill-color: #698caa !important;
  color: #698caa !important;
}

.icon {
  width: 70px;
  height: 70px;

  font-size: 30px;
  line-height: 80px;

  text-align: center;
  margin-right: -70px;

  position: relative;
  z-index: 1;

  color: #586c85;
  float: left;
}

.icon + input {
  padding-left: 70px;

  &:focus {
    color: #698caa !important;
  }
}

.active {
  color: #698caa !important;
}

.login-button {
  width: 100%;
  height: 50px;

  font-size: 16px;

  border-radius: 0px 0px 5px 5px;

  color: white;
  background-color: #e45d35;
}

.invalid {
  display: block;
  color: white;

  text-align: center;
  margin-top: 20px;
}

.shake {
  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-name: shake;
}

@keyframes shake {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    transform: translate3d(5px, -5px, 0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-5px, 5px, 0);
  }
}

@media (max-width: 500px) {
  .logo-wrap {
    padding: 80px 0;
  }
}
</style>
